import { useEffect } from 'react';

/**
 * Hook to set the document title with a consistent suffix
 * @param title - The page-specific part of the title
 * @param options - Optional configuration
 */
export function useDocumentTitle(
  title: string,
  options: {
    addSuffix?: boolean; // Whether to add the site name suffix
    suffix?: string; // Custom suffix to use instead of default
  } = {},
) {
  const { addSuffix = true, suffix = 'MilestoneMap.org' } = options;

  useEffect(() => {
    const newTitle = addSuffix ? `${title} | ${suffix}` : title;
    document.title = newTitle;
  }, [title, addSuffix, suffix]);
}
